import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';
import { usePaidAssessment } from '../utils/usePublicConfig';

const AszfPage = () => {
  const paidAssessment = usePaidAssessment();
  return (
  <LegalPageLayout
    testId="aszf-page"
    title="Általános Szerződési Feltételek (ÁSZF)"
    metaDescription="Az Orosz Coaching online és személyes fitness coaching szolgáltatásainak igénybevételi feltételei – fizetés, lemondás, adatkezelés."
    canonicalPath="/aszf"
    updatedAt="2026-02-19"
  >
    <section>
      <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
        1. Általános rendelkezések
      </h2>
      <p>
        A jelen ÁSZF szabályozza a(z) <strong>Orosz Gábor</strong> (Szolgáltató) által az{' '}
        <a href="https://oroszcoaching.hu" className="text-yellow-700 hover:text-yellow-600 font-semibold">oroszcoaching.hu</a>{' '}
        weboldalon keresztül nyújtott online és személyes fitness coaching, valamint
        időpontfoglalási szolgáltatások igénybevételének feltételeit.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
        2. Szolgáltatások köre és az időpontfoglalás
      </h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>A Felhasználó a weboldalon található beépített naptár segítségével konzultációs időpontot foglalhat Szolgáltatóhoz.</li>
        <li>Az időpontfoglalás a Szolgáltató általi <strong>e-mailes visszaigazolással</strong> válik véglegessé.</li>
        <li>A weboldalon található kalkulátorok és Tudástár cikkek ingyenesen, tájékoztató jelleggel érhetők el, és <strong>nem helyettesítik az orvosi vagy szakorvosi szakvéleményt</strong>.</li>
        <li>A Kliens Portálon (fiokom) elérhető <strong>étrend funkció általános mintaétrendet</strong> szolgáltat a Felhasználó által megadott vagy a kalkulátor által számolt kalória- és makrótápanyag-célok alapján. Az étrend <strong>nem minősül dietetikai tanácsadásnak</strong>, <strong>nem személyre szabott terápiás étrend</strong>, és <strong>nem helyettesíti az orvosi, dietetikusi vagy szakorvosi szakvéleményt</strong>. Krónikus betegség, ételallergia, ételintolerancia, terhesség, szoptatás vagy gyógyszeres kezelés esetén a Felhasználó köteles az étrend bevezetése előtt kezelőorvosához vagy okleveles dietetikushoz fordulni. Szolgáltató az étrend követéséből származó egészségügyi következményekért <strong>felelősséget nem vállal</strong>.</li>
      </ul>
    </section>

    <section>
      <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
        3. A szerződés létrejötte és a fizetési feltételek
      </h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>A weboldalon a Felhasználónak lehetősége van <strong>online coaching szolgáltatást (1 hónap)</strong>, valamint <strong>offline személyes edzés bérletet (8 vagy 12 alkalom)</strong> vásárolni.</li>
        <li>A fizetés a <strong>Barion Payment Zrt.</strong> biztonságos online bankkártyás rendszerén keresztül történik. A sikeres fizetés után a rendszer azonnal, automatikusan kiállítja az elektronikus számlát a <strong>Számlázz.hu</strong> rendszerén keresztül, és elküldi a Felhasználó e-mail címére.</li>
        <li>A fizetés megerősítésével a szerződés azonnal létrejön, és elindul az <strong>automatizált online onboarding</strong> folyamat.</li>
      </ul>
      <div className="mt-4 bg-yellow-50 border-l-4 border-yellow-500 p-4 rounded-r-lg">
        <p className="text-sm text-gray-800 leading-relaxed">
          <strong>Barion adattovábbítási nyilatkozat:</strong> A bankkártyás fizetési szolgáltatást a
          <strong> Barion Payment Zrt.</strong> biztosítja (MNB engedély száma: <strong>H-EN-I-1064/2013</strong>).
          A bankkártya adatok a kereskedőhöz nem jutnak el.
        </p>
      </div>
      <div className={`mt-4 border-l-4 p-4 rounded-r-lg ${paidAssessment ? 'bg-amber-50 border-amber-500' : 'bg-emerald-50 border-emerald-600'}`}>
        <p className="text-sm text-gray-800 leading-relaxed">
          <strong>Állapotfelmérés:</strong>{' '}
          {paidAssessment ? (
            <>
              A részletes mozgásszervi állapotfelmérés és kérdőíves anamnézis (0. alkalom) díja{' '}
              <strong>10.000 Ft</strong>, amelyet a Szolgáltató bérletvásárlás esetén teljes egészében jóváír.
            </>
          ) : (
            <>
              A részletes mozgásszervi állapotfelmérés és kérdőíves anamnézis (0. alkalom) a Szolgáltató
              jelenlegi gyakorlata szerint <strong>díjmentes</strong>, bérletvásárlástól függetlenül.
              A Szolgáltató fenntartja a jogot, hogy a felmérés díjazását a jövőben – a honlapon
              előzetesen közzétett díjszabás szerint – megváltoztassa.
            </>
          )}
        </p>
      </div>
      <div className="mt-4 bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-lg">
        <p className="text-sm text-gray-800 leading-relaxed">
          <strong>Terembérlet:</strong> A Szolgáltató által feltüntetett programárak az edzői mentorálás
          (személyi vagy kiscsoportos edzés) és a részletes állapotfelmérés díját tartalmazzák.
          A programárak <strong>nem tartalmazzák</strong> a <strong>BB Gym Miskolc</strong>{' '}
          (3526 Miskolc, Szeles u. 71.) edzőterembe történő belépés / terembérlet díját, amelyet
          a Megrendelő a helyszínen, külön jogviszony keretében, a terem üzemeltetőjének mindenkori
          díjszabása szerint rendez.
        </p>
      </div>
      <div className="mt-4 bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-lg">
        <p className="text-sm text-gray-800 leading-relaxed">
          <strong>Egyedi ajánlatok:</strong> A Szolgáltató egyedi, személyre szabott ajánlatokat biztosíthat,
          amelyek kizárólag a Szolgáltató által megküldött egyedi fizetési linken keresztül,
          az azon feltüntetett áron és a megadott érvényességi időn belül vehetők igénybe.
          Az egyedi ajánlat egyszeri, más kedvezménnyel nem vonható össze, és kizárólag a címzett Megrendelő számára érvényes.
          A feltüntetett ár az edzői mentorálás díját tartalmazza; a BB Gym Miskolc terembe való belépés / terembérlet nem része az árnak.
        </p>
      </div>
    </section>

    <section>
      <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
        4. Elállási jog (14 napos visszavonási jog)
      </h2>
      <p className="mb-3">
        A 45/2014. (II. 26.) Korm. rendelet alapján a Felhasználót (mint fogyasztót) <strong>14 napos
        elállási jog</strong> illeti meg a digitális szolgáltatási csomagok (online coaching, edzés-
        és táplálkozási tervek) megvásárlásától számítva, a <strong>személyes edzés vagy aktív
        online coaching megkezdése előtt</strong>.
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li>Az elállási jog gyakorlása esetén a már kifizetett szolgáltatási díjat 14 napon belül visszatérítjük.</li>
        <li>Amennyiben a Felhasználó <strong>kifejezetten kérte a szolgáltatás 14 napon belüli megkezdését</strong> (pl. azonnali edzéstervet kapott vagy elkezdte az aktív edzéseket), úgy a már teljesített, arányos szolgáltatási díj megfizetésére kötelezett, az el nem fogyasztott rész visszatérítésre kerül.</li>
        <li>
          Az elállást a Felhasználó digitálisan, az online{' '}
          <a href="/elallasi-nyilatkozat" className="text-yellow-700 hover:text-yellow-600 font-semibold underline">
            Elállási Nyilatkozat
          </a>{' '}
          űrlapon vagy az <strong>info@oroszcoaching.hu</strong> e-mail címen jelentheti be a sikeres
          fizetést követő 14 napon belül.
        </li>
      </ul>
    </section>

    <section>
      <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
        5. Lemondási feltételek (Személyes és Online konzultációk)
      </h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>A lefoglalt időpontok lemondása vagy módosítása <strong>díjmentesen legkésőbb a lefoglalt időpont előtt 24 órával</strong> lehetséges a megadott e-mail címen keresztül.</li>
        <li><strong>24 órán belüli lemondás</strong> vagy <strong>meg nem jelenés esetén</strong> a Szolgáltató jogosult a szolgáltatást teljesítettnek tekinteni, vagy a bérletből az alkalmat levonni.</li>
      </ul>
    </section>

    <section>
      <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
        6. Panaszkezelés és jogviták (Békéltető Testület)
      </h2>
      <p className="mb-3">
        Esetleges fogyasztói panasz esetén a Felhasználó elsősorban az <strong>info@oroszcoaching.hu</strong>{' '}
        címen, vagy az Impresszumban megadott elérhetőségeken jelezheti igényét, melyet a Szolgáltató
        30 napon belül kivizsgál és írásban válaszol.
      </p>
      <p className="mb-3">
        Amennyiben a panasz rendezése nem vezet eredményre, a Felhasználó a Szolgáltató székhelye szerint
        illetékes <strong>Borsod-Abaúj-Zemplén Vármegyei Békéltető Testülethez</strong> fordulhat:
      </p>
      <ul className="list-disc pl-6 space-y-1 mb-4">
        <li><strong>Cím:</strong> 3525 Miskolc, Szentpáli u. 1.</li>
        <li><strong>E-mail:</strong>{' '}
          <a href="mailto:bekeltetes@bokik.hu" className="text-yellow-700 hover:text-yellow-600 font-semibold">
            bekeltetes@bokik.hu
          </a>
        </li>
        <li><strong>Telefon:</strong> +36 46 501 091</li>
      </ul>
      <p>
        Online vásárlás esetén az Európai Bizottság által biztosított, ingyenes{' '}
        <strong>Online Vitarendezési Platform</strong> (ODR) is igénybe vehető:{' '}
        <a
          href="https://ec.europa.eu/consumers/odr/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-yellow-700 hover:text-yellow-600 font-semibold break-all"
        >
          https://ec.europa.eu/consumers/odr/
        </a>
      </p>
    </section>

    <section>
      <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
        7. Adatvédelem
      </h2>
      <p>
        A weboldal használata során megadott személyes adatokat (név, e-mail cím, testi adatok) a Szolgáltató a
        hatályos <strong>GDPR jogszabályoknak megfelelően, bizalmasan kezeli, és külső félnek nem adja át</strong>.
        Az adatokat kizárólag a kalkulációk elmentésére és a heti edukációs hírlevelek kiküldésére használja fel.
        A Felhasználó a levelek alján lévő linkkel <strong>bármikor ingyenesen leiratkozhat</strong>.
      </p>
      <p className="mt-3 text-sm">
        A részletes adatkezelési információk a{' '}
        <a href="/adatvedelem" className="text-yellow-700 hover:text-yellow-600 font-semibold">Adatkezelési Tájékoztatóban</a> érhetők el.
      </p>
    </section>
  </LegalPageLayout>
  );
};

export default AszfPage;
